import { render, staticRenderFns } from "./ExtraCostData.vue?vue&type=template&id=24f7089b&scoped=true&"
import script from "./ExtraCostData.vue?vue&type=script&lang=js&"
export * from "./ExtraCostData.vue?vue&type=script&lang=js&"
import style0 from "./ExtraCostData.vue?vue&type=style&index=0&id=24f7089b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7089b",
  null
  
)

export default component.exports